export default __webpack_public_path__ + "static/V2-Carton-Mineral_ISO-e9f838a410830e579f2d778082d60a76.png";